export default "__VITE_ASSET__CDsHSJzp__"